import SectionHeader from './SectionHeader';

export default function AwardsSection({ data, template, accent }) {
  if (!data.awards || data.awards.length === 0) return null;

  return (
    <div className="resume-section">
      <SectionHeader template={template} accent={accent}>Awards &amp; Honors</SectionHeader>
      <div style={{ fontFamily: template.bodyFont, fontSize: '10.5pt', color: '#1c1c1c', lineHeight: 1.5 }}>
        <ul style={{ margin: 0, paddingLeft: '0.22in' }}>
          {data.awards.map((a, i) => (<li key={i} style={{ marginBottom: '0.03in' }}>{a}</li>))}
        </ul>
      </div>
    </div>
  );
}
